import { render } from "./DraftBillsModernPanel.vue?vue&type=template&id=dd07f7fc"
import script from "./DraftBillsModernPanel.vue?vue&type=script&lang=js"
export * from "./DraftBillsModernPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__